

var formattingMixin = {
    methods: {

     worldNameFormat : function (worldName) {
          //console.log(store)
          //console.log(store.awards_store.currentSession.badges)
       console.log(worldName)
            return worldName.replaceAll('&',"").replaceAll(' ',"_").toLowerCase()
               
             

      },
      worldNameToDbNameFormat : function (worldName) {
        //console.log(store)
        //console.log(store.awards_store.currentSession.badges)
     console.log(worldName)
          return  worldName.replaceAll('_',"").toLowerCase();
          //return worldName.toLowerCase().split('_').map((x)=>{var firstchar= x.charAt(0).toUpperCase(); return firstchar+ x.slice(1)}).join("")
             
           

    },
    }
  };
  export default formattingMixin
